import React from 'react';
import CihazSorgulamaPanel from '../components/CihazSorgulamaPanel';

const CihazSorgulamaPage = () => (
  <main className="main-content">
    <div className="content-header">
      <h1>Cihaz Sorgulama</h1>
      <p className="content-subtitle">Seri numarası ile cihaz, müşteri ve servis kayıtlarını sorgulayın</p>
    </div>
    <CihazSorgulamaPanel buildServisKaydiLink={(id) => `/service-records/${id}/update`} />
  </main>
);

export default CihazSorgulamaPage;
